import React from "react";
import ReactPlayer from "react-player";
import Human from "../assets/images/svg/human-devlopment.svg";
import Social from "../assets/images/svg/social-devlopment.svg";
import Ecnomic from "../assets/images/svg/economics-devlopment.svg";
import Envirment from "../assets/images/svg/enviromental-devlopment.svg";
function Devlepmenttypes() {
  return (
    <>
      <div className="w-100 position-relative rose-video-height overflow-hidden">
        <div
          id=""
          className="position-relative rose-video-height overflow-hidden"
        >
          <ReactPlayer
            className="react-player"
            url="https://vz-e28eac45-f0a.b-cdn.net/32389e50-da2d-4449-b1e1-234cdfadad50/playlist.m3u8"
            width="100%"
            playing={true}
            loop={true}
            muted={true}
            height="100%"
          />
        </div>
        <div className="position-absolute top-50 start-50 translate-middle w-100 h-100">
          <div className="d-md-flex justify-content-md-end justify-content-center h-100">
            <div className="d-sm-flex w-100 justify-content-around bg-gradient-white mb-0 mb-sm-4 mb-md-0">
              <div
                data-aos="zoom-in"
                className="d-flex align-items-center justify-content-center devepmemt_card_hov w-100 mb-4 mb-sm-0 mx-auto text-center pt-4 pt-md-0 pb-2 pb-md-0"
              >
                <div>
                  <img className="width_adjust" src={Human} alt="" />
                  <h5 className="text-uppercase text-center color-white font-lg font-medium mt-5">
                    human<span className="d-block"> development</span>
                  </h5>
                </div>
                {/* <div className='border_left'></div> */}
              </div>
              <div
                data-aos="zoom-in"
                className="d-flex flex-column align-items-center justify-content-center devepmemt_card_hov w-100 mb-4 mb-sm-0 mx-auto text-center pt-4 pt-md-0 pb-2 pb-md-0"
              >
                <img className="width_adjust" src={Social} alt="" />
                <h5 className="text-uppercase text-center color-white font-lg font-medium mt-5">
                  Social<span className="d-block"> development</span>
                </h5>
              </div>
            </div>
            <div className="d-sm-flex w-100 justify-content-around mb-0 mb-sm-4 mb-md-0 pt-sm-4 pt-md-0">
              <div
                data-aos="zoom-in"
                className="d-md-flex flex-column align-items-center justify-content-center devepmemt_card_hov w-100 mb-4 mb-sm-0 mx-auto text-center pt-4 pt-md-0 pb-2 pb-sm-0"
              >
                <img className="width_adjust" src={Ecnomic} alt="" />
                <h5 className="text-uppercase text-center color-white font-lg font-medium mt-5">
                  economic<span className="d-block"> development</span>
                </h5>
              </div>
              <div
                data-aos="zoom-in"
                className="d-md-flex flex-column align-items-center justify-content-center devepmemt_card_hov w-100  mx-auto text-center pt-4 pt-md-0 pb-4 pb-md-0"
              >
                <img className="width_adjust" src={Envirment} alt="" />
                <h5 className="text-uppercase text-center color-white font-lg font-medium mt-5">
                  environmental<span className="d-block"> development</span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Devlepmenttypes;
